<template>
  <div>
    <swiper-item :params="params"></swiper-item>
    <div class="food-img">
      <img :src="data.pictureName" alt>
    </div>
    <div class="food-info">
      <p class="food-alias" v-if="data.foodAlias">{{data.foodName}}别名：{{data.foodAlias|formatAlias}}</p>
      <!-- <p @click="showShare">我是假的分享按钮</p> -->
      <div class="intro" v-for="(item,index) in data.canEat" :key="index">
        <div class="intro-title">
          <span class="intro-name">{{item.crowd}}</span>
          <span class="intro-label">
            <can-eat-label :num="item.show"></can-eat-label>
            <span v-html="formatCanEat(item.show)"></span>
          </span>
        </div>
        <div class="intro-content">{{item.content}}</div>
      </div>
    </div>
    <van-actionsheet v-model="show">
      <div class="share">
        <div class="share-item">
          <div class="share-img">
            <img src="@/assets/images/share_icon_qq_default.png" alt>
          </div>
          <p class="share-way">微信好友</p>
        </div>
        <div class="share-item">
          <div class="share-img">
            <img src="@/assets/images/share_icon_wechat_default.png" alt>
          </div>
          <p class="share-way">QQ</p>
        </div>
      </div>
      <div class="cancal-share" @click="cancalShare">取消</div>
    </van-actionsheet>
  </div>
</template>
<script>
import { getDetails, getWxConfig } from "@/api/eating.js";
import SwiperItem from "@/view/eating/components/swiper-item";
import CanEatLabel from "@/view/eating/components/can-eat-label";
import { Actionsheet } from "vant";
import wx from "weixin-js-sdk";

export default {
  data() {
    return {
      data: {},
      show: false,
      params: {
        phaseInquire: 0,
        bannerQuantity: 100,
        businessKey: this.$isWechat? 'GZH_WHETHER_CAN_EAT_DETAIL': 'APP_WHETHER_CAN_EAT_DETAIL'
      }
    };
  },
  components: { SwiperItem,CanEatLabel, [Actionsheet.name]: Actionsheet },
  async created() {
    const res = await getDetails(this.$route.query.foodId);
    this.data = res.data;
    this.data.canEat.sort((a, b) => {
      return a.sort - b.sort;
    });
    console.log(this.data);
    document.title = this.data.foodName;
    // let url = window.location.href.split("#")[0];
    const shareTitle = res.data.foodName + "能不能吃？——孕e家告诉您";
    const shareDesc = this.getShareDesc(this.data);
    wx.ready(function() {
      //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: res.data.pictureName, // 分享图标
        success: function() {
          // 设置成功
          console.log("分享成功");
        },
        cancal: function() {}
      });
      wx.updateTimelineShareData({
        title: shareTitle, // 分享标题
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: res.data.pictureName, // 分享图标
        success: function() {
          // 设置成功
          console.log("分享成功");
        }
      });
    });
  },
  filters: {
    formatAlias: function(value) {
      return value && value.replace(/，/g, "、");
    }
  },
  methods: {
    formatCanEat: function(value) {
      switch (value) {
        case 0:
          return "<span class='color-can'>能吃</span>";
          break;
        case 1:
          return "<span class='color-ban'>不能吃</span>";
          break;
        case 2:
          return "<span class='color-notice'>慎吃</span>";
          break;
        case 3:
          return "<span class='color-can'>4个月以上能吃</span>";
          break;
        case 4:
          return "<span class='color-can'>6个月以上能吃</span>";
          break;
        case 5:
          return "<span class='color-can'>8个月以上能吃</span>";
          break;
        case 6:
          return "<span class='color-can'>10个月以上能吃</span>";
          break;
        case 7:
          return "<span class='color-can'>12个月以上能吃</span>";
          break;
        case 8:
          return "<span class='color-can'>18个月以上能吃</span>";
          break;
        case 9:
          return "<span class='color-can'>24个月以上能吃</span>";
          break;
        case 10:
          return "<span class='color-can'>36个月以上能吃</span>";
          break;
      }
    },
    cancalShare() {
      this.show = false;
    },
    showShare() {
      this.show = true;
    },
    getShareDesc(data) {
      let str = data.foodAlias
        ? `${data.foodName}别名：${this.$options.filters.formatAlias(
            data.foodAlias
          )}。`
        : "";
      let strArr = [];
      data.canEat.map(item => {
        strArr.push(item.content);
      });
      return str + strArr.join("");
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log(to, from);
  //   if (to.path == "/eating/list") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // }
};
</script>
<style lang="less">
.color-can {
  color: #7ed321;
  font-weight: 600;
}
.color-ban {
  color: #ff7e6d;
  font-weight: 600;
}
.color-notice {
  color: #f7b12e;
  font-weight: 600;
}
.food-img {
  width: 100%;
  img {
    width: 100%;
    display: block;
  }
}
.food-alias {
  font-size: 16px;
  color: #666;
  min-height: 52px;
  margin: 0;
  display: flex;
  align-items: center;
}
.food-info {
  padding: 0 15px;
}
.intro {
  border-top: 1px solid #e5e5e5;
  padding: 20px 0;
  &-title {
    height: 22px;
    line-height: 22px;
    margin-bottom: 15px;
  }
  &-name {
    color: #222;
    font-size: 18px;
    margin-right: 15px;
    font-weight: 600;
  }
  &-label {
    font-size: 14px;
    color: #222;
    vertical-align: 2px;
    font-weight: 400;
  }
  &-content {
    color: #222222;
    font-size: 16px;
    line-height: 28px;
    // letter-spacing: 1px;
    font-weight: 400;
  }
  .eat-label {
    vertical-align: -2px;
  }
  .label-box {
    margin-right: 4px;
  }
  .eat-num-label {
    vertical-align: -0.05333rem;
  }
}
.share {
  display: flex;
  justify-content: space-around;
  height: 127px;
  align-items: center;
  background: #f7f7f7;
  &-item {
    height: 84px;
  }
  &-img {
    width: 60px;
    height: 60px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-way {
    color: #666;
    font-size: 0.29333rem;
    margin: 0;
    text-align: center;
  }
}
.cancal-share {
  height: 48px;
  line-height: 48px;
  background: #ffffff;
  font-size: 14px;
  color: #666;
  text-align: center;
}
</style>

